import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { InventaryService } from '../services/inventary.service';
import { ContractService } from '../services/contract.service';
import { Inventary } from '../models/inventary.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'inventary',
  templateUrl: '../views/products/inventary.html',
  providers: [InventaryService,ContractService]
})
export class InventaryComponent{
  public title: string;
  public inventaries: Inventary[];
  public submitInventaryModel: Inventary;
  public message: any;
  public mode: string;
  public wait:boolean;
  public inventaryPrivilege:number;
  public privileges:Privileges[];
  public linkToPdf:string;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private inventaryService: InventaryService,
    public sharedVariables: VariableService,
    public contractService: ContractService
  )
  {
      this.title = null;
      this.mode = "submit-add";
      this.submitInventaryModel = new Inventary(0,null,null,null,null,null,'');
      this.wait = true;
      this.inventaryPrivilege = null;
  }

  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.inventaryPrivilege == 1){
                                    this.getAllInventaries();
                                    this.wait=false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllInventaries()
  {
    this.inventaryService.getInventaries().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.inventaries = result.data;
          console.log(this.inventaries);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  onSubmit()
  {
    this.updateInventary();
    setTimeout(()=> {
                      this.message = null;
                    },this.sharedVariables.timeMessage);
    setTimeout(()=> {
                      this.getAllInventaries();
                      this.submitInventaryModel = new Inventary(0,null,null,null,null,null,'');
                    },this.sharedVariables.timeToLoad);
    console.log("mode",this.mode);
  }

  saveInventary()
  {
    this.inventaryService.addInventary(this.submitInventaryModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  editInventary(pInventary: Inventary)
  {
    this.mode = "submit-update";
    this.submitInventaryModel = Object.assign({}, pInventary);
    console.log("Checkout objects");
    console.log("mode ",this.mode);
  }

  updateInventary()
  {
      let id = this.submitInventaryModel.ID;
      console.log("objeto update ",this.submitInventaryModel);
      this.inventaryService.updateInventary(id,this.submitInventaryModel).subscribe(
        response => {
          if(response.code == 200)
          {
            this.message = response.data;
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
  }

  deleteInventary(id: number)
  {
    this.inventaryService.deleteInventary(id).subscribe(
        response => {
          if(response.code == 200){
            this.getAllInventaries();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  generateContract(service_id:number,id_contract:number,customer_id:number,report_name:string)
  {
    this.contractService.generateContract(1,1,1,report_name).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          setTimeout(()=> {
                           this.linkToPdf = result.data;
                           window.open(this.linkToPdf,'_blank');
                           console.log("link para el pdf",this.linkToPdf);
                         },this.sharedVariables.timeToReport);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  cleanObject()
  {
    this.submitInventaryModel = new Inventary(0,null,null,null,null,null,'');
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.inventaryPrivilege = response.data[0].Inventary;
            console.log("Privilegios del usuario",this.inventaryPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/inventary.component.ts